<template>
    <div class="loginVue">
         <div class="login-wrap" v-loading="loading">
            <div class="container">
                <div class="login-center">
                    <div class="col-md-7 col-sm-12 col-xs-12">
                        <div class="containing-table">
                            <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left">
                                <img src="static/assets/images/logo.png" id='img-upload' />
                            </div>
                            <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right">
                                <transition name="">
                                    <div v-if="tab == 'loginScreen'" class="login-screen">
                                       <form>
                                        <div class="form-group">
                                            <div class="clearfix">
                                                <div class="text-left ps2" style="padding-bottom: 10px;">
                                                    <p class="o-forget-password">The Call Steward DB is offline for repairs and should return after it's maintenance by 10 am Eastern.</p>
                                                    <p class="o-forget-password">Our apologies for the Inconvenience</p>
                                                    <p class="o-forget-password">www.callsteward.com</p>
                                                </div>
                                                <div class="form-group-left o-login-field">
                                                    <!-- <label>The Call Steward DB is offline for repairs and should return after it's maintenance by 10 am Eastern</label> -->
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </form>
                                   </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5 col-sm-12 col-xs-12">
                        <div class="containing-table">
                            <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left login-left-spacing">
                                <!-- <img src="static/assets/images/logo.png"> -->
                                <img v-if="login_image && login_image != '' && login_image != 'NULL'" :src="login_image" width="100"/>
                                <img v-if="!login_image || login_image == '' || login_image == 'NULL'" src="static/assets/images/logo.png" width="100" />
                            </div>
                            <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right login-right-spacing">
                                <transition name="">
                                    <div class="login-screen login-right-screen">
                                        <!-- <p v-html="login_text"></p> -->
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </div>

      </div>
</template>
<script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';

    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',
                employeeId: 'employeeId',
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
                
                  return("desktop" != check ? !0 : !1);

            }
        },
        data() {
            return {
                loginHide:false,
                email: "",
                password: "",
                validation_err: 0,
                credential_err: "",
                tab: 'loginScreen',
                resetemail: '',
                resetInfo_err: '',
                redirect_link: '',
                domainLogo: '',
                getBaseURL: '',
                login_image:'',
                login_text:'',
                clientdata:null,
                loading:false

            }
        },
        watch: {
            email: function() {
                this.credential_err = "";
            },
            password: function() {
                this.credential_err = "";
            }
        },
        methods: {
        },
        mounted() {
            //alert('created');
            $('.loginVue').parent('.wrapper').css('margin-left', '0');
        },
        beforeMount() {
            this.getBaseURL = global[0].IMAGE_URL;
        },
               
        created() {
            /* switch view port for mobile/desktop */
            const isMobile = this.deviceDetector;
            // console.log('deviceDetector',isMobile);
            if(isMobile && document.location.href.split('#')[0] !='http://localhost:8080/'){
                // viewport.setAttribute('content', 'width=1024');
                window.location.href = window.location.href.split('#')[0]+"mobile/";
            }else{
                this.loginHide = true;
                // viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1, user-scalable=no');
            }
        }
    }

</script>
<style scoped>
    .fade-enter {
        opacity: 0
    }

    .fade-enter-active {
        transition: opacity .40s ease
    }

    .fade-leave {}

    .fade-leave-active {
        transition: opacity .40s ease;
        opacity: 0
    }

</style>



// WEBPACK FOOTER //
// src/components/siteDown.vue